import RoomList from './room-list';
import PkList from './pk-list';
import Sidebar from './sidebar';

const Main = (props) => {
  const { data } = props;
  return (
    <section id="sec-main" className="common-sec main-sec clearfix">
      <div className="all-stars-list-wrap">
        <div className="sec-header">
          <i className="icon-index icon-index-hot"></i>
          <div className="sec-label">热门直播</div>
          <div className="sec-header-tabs clearfix">
            <span
              className="tab active"
              data-action="all"
              data-sawebclick="id=001t04b001"
              data-log="event=首页tab"
            >
              全部
            </span>
            <span
              className="tab"
              data-action="pk"
              data-sawebclick="id=001t04b002"
              data-log="event=首页tab"
            >
              连麦
            </span>
            <span
              className="tab"
              data-action="rookie"
              data-sawebclick="id=001t04b003"
              data-log="event=首页tab"
            >
              新秀
            </span>
            <span
              className="tab long-tab"
              data-action="recent"
              data-sawebclick="id=001t04b004"
              data-log="event=首页tab"
            >
              最新开播
            </span>
            <span
              className="tab"
              data-action="mobile"
              data-sawebclick="id=001t04b005"
              data-log="event=首页tab"
            >
              手机
            </span>
          </div>
          <div className="search-area">
            <input type="text" placeholder="搜索主播昵称或者ID" />
            <i className="icon-index icon-index-search"></i>
          </div>
        </div>
        <div className="list-wrap">
          <div className="common-list list-all active">
            <RoomList
              data={{
                list: data.room_list,
                type: 'outer',
                isLazy: true,
                saId: '001t04l01+000',
              }}
              clickfrom="J103"
            ></RoomList>
          </div>
          <div className="list-pk pk-sec">
            <PkList
              data={{
                list: data.pk_list,
                saId: '001t04l02+000',
              }}
              clickfrom="J102"
            ></PkList>
          </div>
          <div className="common-list list-rookie">
            <RoomList
              data={{
                list: data.new_room_list,
                type: 'outer',
                isLazy: true,
                saId: '001t04l03+000',
              }}
              clickfrom="J108"
            ></RoomList>
          </div>
          <div className="common-list list-recent">
            <RoomList
              data={{
                list: data.recent_room_list,
                type: 'outer',
                isLazy: true,
                saId: '001t04l04+000',
              }}
              clickfrom="J110"
            ></RoomList>
          </div>
          <div className="common-list list-mobile">
            <RoomList
              data={{
                list: data.mobile_room_list,
                type: 'outer',
                isLazy: true,
                saId: '001t04l05+000',
              }}
              clickfrom="J109"
            ></RoomList>
          </div>
          <div className="common-list list-search"></div>
        </div>
      </div>

      <Sidebar data={data} />
    </section>
  );
};

export default Main;
